module.exports = __webpack_public_path__ + "static/media/PeerFiveBuddy.3c7e86b9.svg";